<template>
  <div
    class="product-safety-information"
    id="product-safety-information"
  >
    <accordion
      ref="accordion"
      class="product-safety-information__accordion"
      :is-content-html="true"
      id="product-safety-information-details"
      :name="$t('ads.main.gpsr.section.name')"
    >
      <div
        slot="content"
        class="product-safety-information__content"
      >
        <div class="product-safety-information__inner-content">
          <string-list
            ref="string-list-manufacturer"
            :heading="$t('ads.main.gpsr.section.manufacturer')"
            :values="productSafetyInformation.manufacturerDetails"
            class="product-safety-information__info-list"
          />
          <string-list
            ref="string-list-responsible-person"
            :heading="$t('ads.main.gpsr.section.responisble.person')"
            :values="productSafetyInformation.responsiblePersonDetails"
            class="product-safety-information__info-list"
          />
        </div>
        <div>
          <string-list
            ref="string-list-safety-notice"
            :heading="$t('ads.main.gpsr.section.safety.notice')"
            :values="productSafetyInformation.safetyNotice !== undefined ? [productSafetyInformation.safetyNotice] : []"
            class="product-safety-information__info-list"
          />
        </div>
      </div>
    </accordion>
  </div>
</template>
<script>
import Accordion from '../accordion/accordion.vue'
import StringList from '../stringList/stringList.vue'

const ProductSafetyInformationAccordion = {
  name: 'product-safety-information-accordion',
  components: {
    Accordion,
    StringList
  },
  props: {
    productSafetyInformation: Object
  },
  methods: {
    openAccordion() {
      this.$refs.accordion.open()
    }
  }
}

export default ProductSafetyInformationAccordion
</script>
